export type PWAInstallStatus = 'yes' | 'veryLikely' | 'unlikely' | 'not';

export function setPWAInstalledStatusAsNot(): void {
  window['pwaInstallStatus'] = 'not' as PWAInstallStatus;
}

export function setPWAInstalledStatusAsYes(): void {
  window['pwaInstallStatus'] = 'yes' as PWAInstallStatus;
}

export async function checkPWAInstallStatus(): Promise<PWAInstallStatus> {
  let existWebAPP = false;
  if ('getInstalledRelatedApps' in window.navigator) {
    const relatedApps: [{ platform: string }] =
      // @ts-ignore
      (await window.navigator?.getInstalledRelatedApps()) ?? [];
    existWebAPP = relatedApps.some(({ platform }) => platform === 'webapp');
    if (existWebAPP) return 'yes';
  }
  const queryMedia = '(display-mode: standalone)';
  const isStandalone = window.matchMedia(queryMedia).matches;
  if (isStandalone) return 'veryLikely';

  // @ts-ignore
  return window?.pwaInstallStatus ?? 'unlikely';
}
